export default __webpack_public_path__ + "static/media/conoteEmpty.e9139f2e.png";